module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-180x180-fbf1e636ac10897e00fbab47f89ae469.png";